import { render, staticRenderFns } from "./item-group.vue?vue&type=template&id=2486c114&"
import script from "./item-group.vue?vue&type=script&lang=js&"
export * from "./item-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports